import Swiper from 'swiper';

// Carousels
class Carousel {
  constructor() {
    const productGalleries = [].slice.call(
      document.querySelectorAll('.product__carousel__items')
    );

    const pressGalleries = [].slice.call(
      document.querySelectorAll('.press__quotes')
    );

    const quoteCarousels = [].slice.call(
      document.querySelectorAll('.quote-carousel__content')
    );

    const promoBar = document.querySelector('.header__promo-bar');

    if (productGalleries.length > 0) {
      productGalleries.forEach(productGallery => {
        this.productCarousel(productGallery);
      });
    }

    if (pressGalleries.length > 0) {
      pressGalleries.forEach(pressGallery => {
        this.pressCarousel(pressGallery);
      });
    }

    if (quoteCarousels.length > 0) {
      quoteCarousels.forEach(quote => {
        this.quoteCarousel(quote);
      });
    }

    if (promoBar) {
      this.promoBarCarousel(promoBar)
    }
  }

  productCarousel(item) {
    this.swiper = new Swiper(item, {
      centeredSlides: true,
      effect: 'fade',
      loop: true,
      shortSwipes: false,
      slidesPerView: 1,
      slidesPerGroup: 1,
      speed: 800,
      watchOverflow: true,
      navigation: {
        prevEl: '.product__carousel__arrow--previous',
        nextEl: '.product__carousel__arrow--next',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      }
    });
  }

  pressCarousel(item) {
    const logos = document.querySelectorAll('.logo');
    const thumbnails = item.nextElementSibling;

    item.addEventListener('click', e => {
      item.classList.add('swiper-slide-active')
    });

    this.swiper = new Swiper(item, {
      allowTouchMove: false,
      autoHeight: true,
      draggable: false,
      direction: 'horizontal',
      longSwipesRatio: 0.2,
      effect: 'fade',
      slidesPerView: 1,
      fadeEffect: {
        crossFade: true
      },
      thumbs: {
        swiper: {
          el: thumbnails,
          draggable: false,
          watchSlidesProgress: true
        }
      }
    });
  }

  quoteCarousel(item) {
    this.swiper = new Swiper(item, {
      autoHeight: true,
      effect: 'fade',
      loop: true,
      slidesPerView: 1,
      fadeEffect: {
        crossFade: true
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      }
    });
  }

  promoBarCarousel(item) {
    this.swiper = new Swiper(item, {
      centeredSlides: true,
      effect: 'fade',
      loop: true,
      slidesPerView: 1,
      slidesPerGroup: 1,
      speed: 800,
      autoplay: {
        delay: 5000,
      },
      fadeEffect: {
        crossFade: true
      }
    });
  }
}

const carouselInit = {
  init() {
    // if element exists init this class
    const carouselElem = [].slice.call(document.querySelectorAll('.carousel'));
    if (carouselElem.length > 0) {
      carouselElem.forEach(el => {
        // eslint-disable-next-line no-unused-vars
        new Carousel(el);
      });
    }
  },
};

export default carouselInit;
